<template>
  <div class="row">
    <div class="col-12">
      <div class="intro__headline-wrapper">
        <h1 v-if="content.data.test_ab.active" class="intro__headline">
          <Ab
            @sample="(value) => (test_ab_content = value)"
            :weight="{ test_ab_contentA: 50, test_ab_contentB: 50 }"
          >
            <div
              slot="test_ab_contentA"
              v-html="content.data.test_ab.intro_a"
            ></div>
            <div
              slot="test_ab_contentB"
              v-html="content.data.test_ab.intro_b"
            ></div>
          </Ab>
        </h1>
        <h1
          v-else
          class="intro__headline"
          v-html="content.data.intro.header"
        ></h1>
        <h2
          v-if="
            content.data.test_ab.active &&
            content.data.test_ab.isSubheaderAbVisible
          "
          class="intro__subheadline"
        >
          <Ab
            @sample="(value) => (test_ab_content = value)"
            :weight="{ test_ab_contentA: 50, test_ab_contentB: 50 }"
          >
            <div
              slot="test_ab_contentA"
              v-html="content.data.test_ab.intro_a_subheader"
            ></div>
            <div
              slot="test_ab_contentB"
              v-html="content.data.test_ab.intro_b_subheader"
            ></div>
          </Ab>
        </h2>
        <h2
          v-if="content.data.intro.isSubheaderVisible"
          class="intro__subheadline"
          v-html="content.data.intro.subheader"
        ></h2>

        <div class="intro__img">
          <img
            v-if="content.data.intro.img && content.data.intro.img !== ''"
            :src="content.data.intro.img"
            alt="10"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ab from "vue-ab";

export default {
  name: "Intro",
  inject: ["content"],
  data() {
    return {
      title: "Introduction",
    };
  },
  components: { Ab },
  methods: {
    overImageFn() {
      this.$emit("show-bottom-menu");
    },
  },
};
</script>
